import Keycloak from 'keycloak-js';
import config from './config';

// keycloak-js 21 does not strip `iss` (added by Keycloak 26) from the callback
// URL, which leaves ?iss=... or #iss=... after processing and triggers a
// login-required redirect loop. Strip it from both search and hash before the
// instance is created so the URL is clean after the code exchange.
let cleanSearch = window.location.search;
let cleanHash = window.location.hash;

if (cleanSearch && cleanSearch.indexOf('iss=') !== -1) {
  cleanSearch = cleanSearch
    .replace(/[?&]iss=[^&]*/g, '')
    .replace(/^&/, '?')
    .replace(/^\?$/, '');
}

if (cleanHash && cleanHash.indexOf('iss=') !== -1) {
  cleanHash = cleanHash
    .replace(/[#&]iss=[^&]*/g, '')
    .replace(/^&/, '#')
    .replace(/^#$/, '');
}

if (
  cleanSearch !== window.location.search ||
  cleanHash !== window.location.hash
) {
  window.history.replaceState(
    null,
    '',
    window.location.pathname + cleanSearch + cleanHash
  );
}

const keycloak = new Keycloak(config.keycloakConfig);

export const getKeycloakHeaders = () => {
  return {
    Authorization: `Bearer ${keycloak.token}`
  };
};

export default keycloak;
